document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.new-grid:has(.slot__collection-grid-banner)');
  if(container){
    const banners = container.querySelectorAll('.slot__collection-grid-banner');
    banners.forEach((banner)=>{
      
    
    const indexModulo = banner.dataset.indexModulo;
    const allItems = container.querySelectorAll('.grid-item');
    
    const bannerIndex = parseInt(banner.dataset.bannerIndex);
    let startIndex = 0,endIndex = allItems.length;
    if(bannerIndex-indexModulo > 0){
      startIndex = bannerIndex-indexModulo;
    }
    if(bannerIndex + (4 - indexModulo) < allItems.length){
      endIndex = bannerIndex + (4 - indexModulo);
    }
      console.log(startIndex,"startIndex",endIndex,"endIndex");
    const prevItems = Array.from(allItems).slice(startIndex, bannerIndex)
    const nextItems = Array.from(allItems).slice(bannerIndex, endIndex);
    console.log(prevItems.length,'prevItems.length',nextItems,'nextItems');
      
    const newParent = document.createElement('div');
    newParent.classList.add('slot-banner-next-item__container');
    
    prevItems.forEach(item => {
      newParent.appendChild(item);
    });
    
    nextItems.forEach(item => {
      newParent.appendChild(item);
    });

    if(prevItems.length > 0){
      container.insertBefore(newParent, banner);
    }else{
      container.insertBefore(newParent, banner.nextSibling);
    }
      
    });
    
  }
});